/* ============================================================
   APEX MALE — Cart drawer gift enforcement
   The drawer markup/animation/quantity/remove are handled by Dawn's
   cart-drawer.js + cart.js. This layer only manages the free e-book gift
   inside the drawer:
     - ensure the gift is present when a real product is in the cart
       (covers the keepalive race);
     - remove a LONE gift so the e-book can never be checked out on its own
       (gift-only enforcement);
     - keep the gift at qty 1.
   It re-renders the drawer contents in place via Section Rendering (no reload).
   Only runs when a £0 gift is configured (window.ApexFreeGift).
   ============================================================ */
(function () {
  var cfg = window.ApexFreeGift;
  var GIFT_ID = cfg && Number(cfg.price) === 0 && cfg.variantId ? Number(cfg.variantId) : null;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function addGift() { return post('/cart/add.js', { items: [{ id: GIFT_ID, quantity: 1 }] }); }
  function setGiftQty(q) { return post('/cart/change.js', { id: String(GIFT_ID), quantity: q }); }

  // Re-render the drawer contents in place (Section Rendering) + header count.
  function refreshDrawer() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ sections: 'cart-drawer,cart-icon-bubble', sections_url: '/cart' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var sec = data.sections && data.sections['cart-drawer'];
        if (sec) {
          var parsed = new DOMParser().parseFromString(sec, 'text/html');
          var src = parsed.querySelector('.drawer__inner');
          var dst = document.querySelector('cart-drawer .drawer__inner');
          if (src && dst) dst.innerHTML = src.innerHTML;
          var drawerEl = document.querySelector('cart-drawer');
          if (drawerEl) drawerEl.classList.toggle('is-empty', (data.item_count || 0) === 0);
        }
        updateBubble(data.item_count);
      })
      .catch(function () {});
  }

  function updateBubble(count) {
    if (count == null) return;
    var bubbles = document.querySelectorAll('.apex-cart__bubble');
    for (var i = 0; i < bubbles.length; i++) bubbles[i].textContent = count;
  }

  function reconcile() {
    if (!GIFT_ID) return;
    getCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var gift = null;
      var qualifying = 0;
      items.forEach(function (i) {
        if (i.variant_id === GIFT_ID) gift = i;
        else qualifying += 1;
      });
      if (gift && (gift.final_price > 0 || gift.price > 0)) return; // safety: never touch a paid line
      if (qualifying > 0 && !gift) { addGift().then(function (ok) { if (ok) refreshDrawer(); }); return; }
      if (qualifying === 0 && gift) { setGiftQty(0).then(function () { refreshDrawer(); }); return; }
      if (gift && gift.quantity !== 1) { setGiftQty(1).then(function () { refreshDrawer(); }); return; }
      // Gift is correct in the cart data — make sure the drawer DOM actually shows
      // every line (the keepalive gift add can land after the drawer first renders).
      var domRows = document.querySelectorAll('cart-drawer .cart-item').length;
      if (domRows !== items.length) refreshDrawer();
    }).catch(function () {});
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var wasActive = drawer.classList.contains('active');
    // Reconcile whenever the drawer becomes active (opened on add-to-cart or cart icon).
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) reconcile();
      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // Also reconcile after Dawn re-renders the cart (quantity change / remove inside
    // the drawer) — e.g. removing the physical product must drop the lone e-book gift.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        if (drawer.classList.contains('active')) reconcile();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
})();
